import { Component, forwardRef } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { SearchableSelectComponent } from '../searchable-select/searchable-select.component';

/**
 * The shared searchable select, re-exposed as a standalone component so SharedModule can use it.
 *
 * `SearchableSelectComponent` is declared in AppModule, which SharedModule cannot see, and a component
 * may belong to only one NgModule. This subclass reuses its class, template and styles unchanged — it is
 * the same control, not a copy — under a selector private to the brand filter.
 */
@Component({
  selector: 'app-brand-select',
  templateUrl: '../searchable-select/searchable-select.component.html',
  styleUrls: ['../searchable-select/searchable-select.component.css'],
  standalone: true,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => BrandSelectComponent),
      multi: true,
    },
  ],
})
export class BrandSelectComponent extends SearchableSelectComponent { }
